export default "__VITE_ASSET__BoPSU7tZ__"